import { ReactNode, useEffect } from 'react';
import { useAuth } from '../lib/auth';
import SystemMessage from '../components/SystemMessage/Index';

type LoginProviderProps = {
  children: ReactNode;
};

export const LoginProvider: React.FC<LoginProviderProps> = ({ children }) => {
  const { user, isLoading, error, login } = useAuth();
  const mustLogin = !isLoading && !error && !user;

  useEffect(() => {
    if (mustLogin) login();
  }, [mustLogin, login]);

  if (isLoading) {
    return <SystemMessage message="loading" />;
  }

  if (error) {
    console.error(error);
    return <SystemMessage isError message="errorLogin" />;
  }

  if (!user) {
    return <SystemMessage message="login" />;
  }

  return <>{children}</>;
};
